import { createDrawerStore } from '../drawer/createDrawerStore';

export const useTransactionDrawerStore = createDrawerStore();
